import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

class Notification extends Component {
  render() {
    const { classes } = this.props;

    const message = this.props.message || this.props.errorMessage;
    const className = this.props.errorMessage ? classes.error : classes.info;

    if (!message) {
      return null;
    }

    return (
      <Snackbar
        open={this.props.open}
        message={message}
        autoHideDuration={6000}        
        onClose={this.props.onCloseNotification}
      >
        <SnackbarContent
          className={className}
          message={message}
        />
      </Snackbar>
    );
  }
}

Notification.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  onCloseNotification: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

Notification.defaultProps = {
  message: null,
  errorMessage: null,
};

const styles = theme => ({
  error: {
    backgroundColor: theme.palette.error.dark,
    fontSize: '2.5rem',           // Increase text size
    padding: '24px 32px',         // Increase padding
    minHeight: '150px',            // Optional: taller container
    transform: 'scale(3)',      // Visually 50% larger
    transformOrigin: 'center',    // Scale from center
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  snackbarContentRoot: {

  },
});

export default withStyles(styles)(Notification);
